import React from 'react'
import { useI18n } from '../state/I18nContext'

const Contact: React.FC = () => {
  const { t } = useI18n()
  const c = t.contact
  return (
    <section className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-8">
      <div>
        <h1 className="text-3xl font-bold mb-2">{c.title}</h1>
        <p className="text-neutral-600 mb-6">{c.description}</p>
        <form className="space-y-3">
          <div>
            <label className="block text-sm mb-1">{c.form.name}</label>
            <input className="w-full border border-neutral-300 rounded px-3 py-2" placeholder={c.form.name} />
          </div>
          <div>
            <label className="block text-sm mb-1">{c.form.email}</label>
            <input className="w-full border border-neutral-300 rounded px-3 py-2" placeholder={c.form.email} />
          </div>
          <div>
            <label className="block text-sm mb-1">{c.form.message}</label>
            <textarea className="w-full border border-neutral-300 rounded px-3 py-2 h-28" placeholder={c.form.message} />
          </div>
          <button type="button" className="bg-amber-600 text-white px-4 py-2 rounded hover:bg-amber-700">{c.form.send}</button>
        </form>
        <p className="text-sm text-neutral-500 mt-4">{c.note}</p>
      </div>

      <div className="border border-neutral-200 rounded p-4">
        <dl className="space-y-2">
          <div>
            <dt className="text-xs text-neutral-500">{c.labels.atelier}</dt>
            <dd>{c.info.address}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-500">{c.labels.schedule}</dt>
            <dd>{c.info.schedule}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-500">{c.labels.phone}</dt>
            <dd>{c.info.phone}</dd>
          </div>
          <div>
            <dt className="text-xs text-neutral-500">{c.labels.email}</dt>
            <dd>{c.info.email}</dd>
          </div>
        </dl>
      </div>
    </section>
  )
}

export default Contact
